module.exports = __webpack_public_path__ + "assets/img/bg_block_02_large.368211d4.png";